import FocusPage from './FocusPage'

export default [{
	path: '/focus/:id',
	component: FocusPage
}]


// WEBPACK FOOTER //
// ./src/pages/focus/focusRoutes.js